import dayjs from 'dayjs';
import { createRoot } from 'react-dom/client';

import { App } from './app';
import { registerDayjsPlugins } from './utils/dayjsPlugins';
import { getInitialLocale } from './utils/translation-utils/utils';

registerDayjsPlugins();

// Set default dayjs locale early to ensure atoms and other modules use it
dayjs.locale(getInitialLocale());

const root = createRoot(document.getElementById('root')!);
root.render(<App />);
